import { SourceRole } from '@/api/types/sources';

export interface SourceRoleItem {
  name: string;
  value: SourceRole;
  description: string;
  shortName: string;
}

export const sourceRoleItems: SourceRoleItem[] = [
  {
    name: 'Source Member',
    value: 'asset_member' as const,
    description: 'Standard source member.',
    shortName: 'Member',
  },
  {
    name: 'Source Admin',
    value: 'asset_admin' as const,
    description: 'Source admin access allows for managing source members and settings.',
    shortName: 'Admin',
  },
];

export const sourceRoleValues = ['asset_admin', 'asset_member'] satisfies [SourceRole, ...SourceRole[]];
export const sourceRoleFilterValues = ['all', ...sourceRoleValues] as const;

export function getSourceRoleName(role: SourceRole): string {
  return sourceRoleItems.find((item) => item.value === role)?.name || role;
}
